jQuery(function($){
    // Mascara para telefone
    var MaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    maskOptions = {
    onKeyPress: function(val, e, field, options) {
        field.mask(MaskBehavior.apply({}, arguments), options);
        }
    };
    
    $('.mask-tel').mask(MaskBehavior, maskOptions);

    // Enviar #form-espera via AJAX
    $('#form-espera').submit(function(e){
        e.preventDefault();
        var form = $(this);
        var formResponse = $('#response-espera');
        var formdata = form.serialize();
        var action = form.attr('action');
        var method = form.attr('method');
        var buttonSubmit = form.find('button[type="submit"]');
        // Disable submit button
        buttonSubmit.attr('disabled', true);
        // Send AJAX request        
        $.ajax({
            url: action,
            type: method,
            data: formdata,
            dataType: 'json',
            success: function(data){                
                // Show response message
                formResponse.show();
                // Set response message                    
                formResponse.find('.message').html(data.message);
                // Clear class after alert and add success class
                formResponse.find('.alert').removeClass('alert-danger');
                formResponse.find('.alert').addClass('alert-success');

                // Google Analytics Event Generate Lead
                gtag('event', 'generate_lead', {
                    'currency': 'BRL',
                    'value': 1,
                    'lead_source': 'form'                    
                });
                
                // Clear form fields
                form[0].reset();
                
                // After 5 Modal bootstrap close
                setTimeout(function(){
                    formResponse.hide();
                    $('#modal-espera').modal('hide');
                }, 5000);
            },
            error: function(data){
                // Show response message
                formResponse.show();
                // Set response message
                formResponse.find('.message').html(data.responseJSON.message);
                // Clear class after alert and add danger class
                formResponse.find('.alert').removeClass('alert-success');
                formResponse.find('.alert').addClass('alert-danger');
            },
            complete: function(){
                // Enable submit button
                buttonSubmit.attr('disabled', false);
            }
        });
    });

    

});